import { render, staticRenderFns } from "./NewRealEstateBindAgentModal.vue?vue&type=template&id=4898d278&scoped=true&"
import script from "./NewRealEstateBindAgentModal.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateBindAgentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4898d278",
  null
  
)

export default component.exports